import { AuthService } from '../service';
import { UserStore } from '../store';
import EmptyScreen from './empty-screen';

function NotFound() {
  const setIsLoggedIn = UserStore((state) => state.setIsLoggedIn);
  setIsLoggedIn(false);
  AuthService.logout();

  return <EmptyScreen heading="Not Found" showButton={false} />;
}

export default NotFound;
